import { EnvironmentService } from "./EnvironmentService";
import { OidcSettings } from "../interfaces/oidcSettings.interface";

function settingsPath(): string {
  return '/assets/settings/settings.json';
}

export class ServerInfo {
  apimSubscriptionKey: string;
  displayName: string;
  serviceUrl: string;
  appInsightsKey: string;
  oidcSettings: OidcSettings;
  attachmentUrl: string;
  env: string;
  contextRoot: string;
  helpFile: string;

  constructor(object: any) {
    this.apimSubscriptionKey = object.apimSubscriptionKey;
    this.displayName = object.displayName;
    this.serviceUrl = object.serviceUrl;
    this.appInsightsKey = object.appInsightsKey;
    this.oidcSettings = object.oidcSettings;
    this.attachmentUrl = object.attachmentUrl;
    this.contextRoot = object.contextRoot;
    this.helpFile = object.helpFile;

    // redirect_uri and silent_redirect_uri are now controlled by each
    // environment's settings.*.json so the value sent to the OIDC provider
    // matches exactly what is registered in the provider metadata.
    // Do NOT override them from window.location.

    this.env = object.env;
  }




  private static current: ServerInfo | null = null;
  private static pending: Promise<ServerInfo> | null = null;

  static get(): Promise<ServerInfo> {
    if (ServerInfo.current !== null) {
      return Promise.resolve(ServerInfo.current);
    }
    if (ServerInfo.pending !== null) {
      return ServerInfo.pending;
    }
    ServerInfo.pending = EnvironmentService.getInstance().getSettings()
      .then((settings) => {
        ServerInfo.current = new ServerInfo(settings);
        return ServerInfo.current;
      })
      .catch((error) => {
        ServerInfo.pending = null;
        throw error instanceof Error ? error : new Error(String(error));
      });
    return ServerInfo.pending;
  }
}
